import { Component, Input, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { cmsActions } from '@src/store/reducers/cmsReducer';
import { userActions } from '@src/store/reducers/userReducer';

import _ from 'lodash';
import $ from 'jquery';
import { vaultActions } from '@src/store/reducers/vaultReducer';
import { agentActions } from '@src/store/reducers/agentReducer';
import { ClusterDialogComponent } from '@app/shared/components/dialogs/cluster-dialog/cluster-dialog.component';
import { UserGitServerCredentials } from '../user-git-server/user-git-server.component';
//import { User } from 'oidc-client';
//import { UserGitServerCredentials } from '@src/app/authorized/usersRolesManagement/usersManagement/users/user-git-server/user-git-server.component';



@Component({
    selector: 'user',
    template: require('./user.component.html'),
    styles: [require('./user.component.scss')]
})
export class UserComponent implements OnInit, OnDestroy {
    @Input() public set user(value) {
        if (!this.waitingForResultTest) {
            this._tempUser = this.deepCopy(value);
            this._user = value;
            this.updateUserInfo();
        } else {
            this.waitingForResultTest = false;
            // chack if not new user && is diff user and reset at
            if ((this._user.id && value.id) && this._user.id !== value.id) {
                this._tempUser = this.deepCopy(value);
                this._user = value;
                this.updateUserInfo();
            }
        }
    }

    public get user() {
        return this._user;
    }

    @Input() public notActions: any;
    @Input() public withToken: any;

    @Output() public onDuplicate = new EventEmitter();
    @Output() public onDelete = new EventEmitter();
    @Output() public onResetPassword = new EventEmitter();
    @Output() public onSetStatus = new EventEmitter();

    private _user: any;
    private unSubscribers: any[];
    private unSubscribe: any;

    public userEmailIsValid = true;
    public userFirstNameIsValid = true;
    public userLastNameIsValid = true;
    public userPasswordIsValid = true;
    public userPasswordConfirmationIsValid = true;
    public actionTitle: any;
    public domainsInUser: any;
    public cmsInUser: any;
    public vaultInUser: any;
    public groupsInUser: any;

    private userGroups: any;
    private domains: any;
    private waitingForResultTest: any;
    private cmss: any;
    private cms: any;
    private _tempUser: any;
    private domain: any;
    public isSyncInfo: boolean = false;
    public vault: any;
    public vaults: any;
    public clusterList: any = [];
    

    private isConnection: boolean = false;
    private clusterId: number;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public async ngOnInit() {
        const clusters = await this.store.dispatch({ type: agentActions.GET_CLUSTER_WITH_AGENT });
        this.vaults = await this.store.dispatch({ type: vaultActions.GET_VAULTS });
        this.clusterList = clusters.filter((cluster: any) => cluster.Agents.length > 0);
        
        this.unSubscribers = [
            this.store.subscribe(() => {
                if (this.store.getState().user.userGroups) {
                    this.userGroups = this.store.getState().user.userGroups;
                }
                if (!this.waitingForResultTest && this.store.getState().user.user) {
                    this.user = this.store.getState().user.user;

                    //populate git dummy git repository if there is none
                    if(this.user && this.user.name !=null)
                    {
                        if(this.user.gitRepositoryServerCredentials == null || this.user.gitRepositoryServerCredentials?.length == 0)
                        {
                            this.user.gitRepositoryServerCredentials = new Array<UserGitServerCredentials>();
                            this.user.gitRepositoryServerCredentials.push(new UserGitServerCredentials(this.user.id, 1,'',''));             
                        }
                    }
                }
                if (this.store.getState().user.domains) {
                    this.domains = this.store.getState().user.domains;
                    if (this.emptyUserDomainsList()) {
                        this.setUserDomains();
                    }
                }
                const cmssState = this.store.getState().cmss;
                if (!this.waitingForResultTest && cmssState.cmss && cmssState.cmss.length > 0) {
                    this.cmss = cmssState.cmss;
                    this.cmss = this.cmss.filter((cms: any) => cms.type !== 6);
                    if (this.emptyCmsUserDomainsList()) {
                        this.setUserCMSs();
                    }
                }
                const vaultsState = this.store.getState().vaults;
                if (!this.waitingForResultTest && vaultsState.vaults_with_credentials &&
                    vaultsState.vaults_with_credentials.length > 0) {
                    this.vaults = vaultsState.vaults_with_credentials;
                    if (this.emptyVaultUserList()) {
                        this.setUserVaults();
                    }
                }
                if (this.waitingForResultTest && cmssState && cmssState.test) {
                    this.cms.test = cmssState.test;
                }

            })
        ];
        this.store.dispatch({ type: userActions.IS_SYNC_ENABLED })
            .then((isSync) => {
                this.isSyncInfo = isSync;
            });
    }
    
    public ngOnDestroy() {
        this.unSubscribers.forEach(us => us());
    }

    private emptyUserDomainsList() {
        return this.domains && this.domains.length > 0
            && (!this.domainsInUser || this.domainsInUser.length === 0);
    }

    private emptyCmsUserDomainsList() {
        return this.cmss && this.cmss.length > 0
            && (!this.cmsInUser || this.cmsInUser.length === 0);
    }

    private emptyVaultUserList() {
        return this.vaults && this.vaults.length > 0
            && (!this.vaultInUser || this.vaultInUser.length === 0);
    }

    public async assignGroup() {
        const modalGroups = this.deepCopy(this.userGroups);
        const availableGroups = _.differenceBy(modalGroups, this.groupsInUser, 'id');
        if (availableGroups.length > 0) {
            this.dialogManagerService.showAddFromListDialog(
                {
                    title: 'Select Group',
                    contentClass: 'assign-groups-popup',
                    placeholder: 'Search Group',
                    items: availableGroups
                },
                (data) => {
                    if (!this.user.groupIds) {
                        this.user.groupIds = [];
                    }
                    const ids = _.map(_.filter(data.items, { selected: true }), 'id');
                    ids.forEach((id: any) => {
                        this.user.groupIds = [...this.user.groupIds, id];
                    });
                    this.setUserGroups();
                }
            );
        } else {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_NO_GROUP']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_GROUP']
            });
        }
    }

    public async addDomain() {
        const domains = this.deepCopy(this.domains);
        const modalDomains = _.differenceBy(domains, this.domainsInUser, 'id');
        if (modalDomains.length > 0) {
            this.dialogManagerService.showAddFromListDialog(
                {
                    title: 'Select Domain',
                    contentClass: 'add-domains-popup',
                    placeholder: 'Search Domain',
                    items: modalDomains
                },
                (data) => {
                    if (!this.user.domainIds) {
                        this.user.domainIds = [];
                    }
                    const ids = _.map(_.filter(data.items, { selected: true }), 'id');
                    ids.forEach((id: any) => {
                        this.user.domainIds = [...this.user.domainIds, id];
                    });
                    this.domain = this.domains.filter((domain: any) => {
                        if (this.user.domainIds.indexOf(domain.id) !== -1) {
                            domain.userName = '';
                            return domain;
                        }
                    });
                    this.domain = _.differenceBy(this.domain, this.domainsInUser, 'id');
                    this.domainsInUser = this.domainsInUser.concat(this.domain);
                    this.bottom(this.domainsInUser.length - 1);
                }
            );
        } else {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_NO_DOMAIN']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_DOMAIN']
            });
        }
    }

    public async addVaults() {
        const vaults = this.deepCopy(this.vaults);
        const modalVault = _.differenceBy(vaults, this.vaultInUser, 'ID');
        if (modalVault.length > 0) {
            modalVault.map(item => item.name = `${item.Name}(${item.VaultType})`);
            this.dialogManagerService.showAddFromListDialog(
                {
                    title: 'Select Vault',
                    contentClass: 'add-domains-popup',
                    placeholder: 'Search Vault',
                    items: modalVault
                },
                () => {
                    let copyAllVaults = this.deepCopy(modalVault);
                    copyAllVaults = copyAllVaults.filter((vault: any) => vault.selected);
                    copyAllVaults = copyAllVaults.map((item) => {
                        item.Connection = {};
                        delete item.name;
                        return item;
                    });
                    this.vaultInUser = this.vaultInUser.concat(copyAllVaults);
                }
            );
        } else {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_NO_VAULT']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_VAULT']
            });
        }
    }

    public async addCMS() {
        const cmss = this.deepCopy(this.cmss);
        const modalCms = _.differenceBy(cmss, this.cmsInUser, 'id');
        if (modalCms.length > 0) {
            this.dialogManagerService.showAddFromListDialog(
                {
                    title: 'Select CMS',
                    contentClass: 'add-domains-popup',
                    placeholder: 'Search CMS',
                    items: modalCms
                },
                () => {
                    let copyAllCmss = this.deepCopy(modalCms);
                    copyAllCmss = copyAllCmss.filter((cms: any) => cms.selected);
                    this.cmsInUser = this.cmsInUser.concat(copyAllCmss);
                    this.bottom(this.cmsInUser.length - 1);
                }
            );
        } else {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_NO_CMS']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_CMS']
            });
        }
    }

    
    public deleteGroup(removedItem: any) {
        const indx = this.user.groupIds.indexOf(removedItem.id);
        this.user.groupIds.splice(indx, 1);
        this.setUserGroups();
    }

    public removeDomain(index: any) {
        this.domainsInUser.splice(index, 1);
    }

    private setUserGroups() {
        this.groupsInUser = [];
        if (this._user && this._user.groupIds && this.userGroups && this.userGroups.length) {
            this.groupsInUser = this.userGroups.filter((group: any) => {
                if (this._user.groupIds.indexOf(group.id) !== -1) {
                    return group;
                }
            });
        }
    }

    private setUserDomains() {
        this.domainsInUser = [];
        if (this._user && this._user.domains && this.domains) {
            this.domainsInUser =
                this._user.domains.map((obj: any) => {
                    return {
                        name: obj.data.name,
                        authenticationType: obj.data.authenticationType,
                        userName: obj.key,
                        id: obj.data.id
                    };
                });
        }
    }

    private setUserCMSs() {
        if (!this.waitingForResultTest) {
            this.cmsInUser = [];
            if (this._user && this._user.cmsCredentials && this.cmss) {
                this.cmsInUser = this._user.cmsCredentials.map((obj: any) => ({
                    name: obj.Key,
                    userName: obj.Value.cmUserName,
                    id: obj.Value.cmsId
                }));
            }
        }
    }

    private setUserVaults() {
        if (!this.waitingForResultTest) {
            this.vaultInUser = [];
            if (this._user && this._user.vaultCredentials && this.vaults) {
                this.vaultInUser = this._user.vaultCredentials.map((obj: any) => ({
                    Name: obj.Key,
                    ID: obj.Value.vaultId,
                    credentials: obj.Value.credentials
                }));
            }
        }
    }

    public removeCms(index: any) {
        if (!this._user.cmss) {
            this.cmsInUser.splice(index, 1);
        }
    }

    public async testCMS(data: any) {
        if (!data.userName || !data.password) {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_USERNAME_OR_PASSWORD_INPUT']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_USERNAME_OR_PASSWORD_INPUT']
            });
            return;
        }
        this.cms = data;
        this.waitingForResultTest = true;
        const result = this.deepCopy(this.cmss.filter((x: any) => x.id === data.id)[0]);
        result.userName = data.userName;
        result.password = data.password;
        this.store.dispatch({ type: cmsActions.TEST_CMS_CONNECTION, payload: result });
    }

    public validateEmail(email: any) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    private validateSaveForm() {
        this.userEmailIsValid = !!this.user.email && this.validateEmail(this.user.email);
        this.userFirstNameIsValid = !!this.user.firstName && this.user.firstName.length <= 20;
        this.userLastNameIsValid = !!this.user.lastName && this.user.lastName.length <= 20;
        this.userPasswordIsValid = !!this.user.id || !!this.user.newPassword;
        this.userPasswordConfirmationIsValid = this.user.newPassword === this.user.confirm_password;

        return this.userEmailIsValid
            && this.userFirstNameIsValid
            && this.userLastNameIsValid
            && this.userPasswordIsValid
            && this.userPasswordConfirmationIsValid;
    }

    public save() {
        if (this.validateSaveForm()) {
            delete this.user.confirm_password;
            this.user.oldPassword = '';
            if (this.user.domainIds && this.domainsInUser) {
                this.user.domainIds = [];
                this.user.domainIds = this.domainsInUser.map((x: any) => {
                    return {
                        key: x.userName || '',
                        data: x.id || ''
                    };
                });
            }
            if (this.cmsInUser) {
                this.user.cmsCredentials =
                    this.cmsInUser.map((x: any) => {
                        return {
                            Key: x.name ? x.name : '',
                            Value: {
                                userId: this.user.isNew ? -1 : this.user.id,
                                cmsId: x.id,
                                cmsName: x.name,
                                cmUserName: x.userName,
                                cmPassword: x.password
                            }
                        };
                    });
            }
            if (this.vaultInUser) {
                this.user.vaultCredentials =
                    this.vaultInUser.map((x: any) => {
                        return {
                            Key: x.Name ? x.Name : '',
                            Value: {
                                userId: this.user.isNew ? -1 : this.user.id,
                                vaultId: x.ID,
                                vaultName: x.Name,
                                credentials: { ...x.credentials }
                            }
                        };
                    });
            }
            this.user.name = this.user.email;
            if (this.user.isNew) {
                this.user.id = -1;
                this.unSubscribe = this.store.subscribe(() => {
                    const userState = this.store.getState().user.user;
                    if (userState) {
                        this.user.id = userState.id;
                        delete this.user.isNew;
                        this.unSubscribe();
                    }
                });
                this.store.dispatch({ type: userActions.ADD_USER, payload: { userData: this.user } });
            } else {
                this.user.groups = [];
                this.user.domains = [];
                this.store.dispatch({
                    type: userActions.SAVE_USER,
                    payload: { userId: this.user.id, userData: this.user }
                });
            }
        }
    }

    public cancel() {
        this._user = this._tempUser;
        this.setUserGroups();
        this._tempUser = this.deepCopy(this._user);
    }

    private updateUserInfo() {
        this.setUserGroups();
        this.setUserDomains();
        this.setUserCMSs();
        this.setUserVaults();
        this.actionTitle = this._user && this._user.status ? 'Disable' : 'Enable';
    }

    private bottom(id: any) {
        if (id > 1) {
            window.setTimeout(() => document.getElementById(id).scrollIntoView(), 50);
        }
    }

    public utilsCopy(toCopy: any, element: any) {
        const textarea = $(`#${element}`);
        textarea[0].select();
        try {
            const successful = document.execCommand('copy');
            if (!successful) {
                throw successful;
            }
        } catch (err) {
            window.prompt('Copy to clipboard: Ctrl+C, Enter', toCopy);
        }
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }

    public sync(): void {
        this.store.dispatch({
            type: userActions.SYNC_USER_INFO,
            payload: { userId: this.user.id }
        })
    }

    public removeVault(index: any) {
        if (!this._user.vaults) {
            this.vaultInUser.splice(index, 1);
        }
    }

    public async testVaultConnection(vaultCredentials) {
        const vault = this.getVaultById(vaultCredentials.ID);
        if (!vault) {
            return;
        }
        this.isConnection = false;
        this.clusterId = -1;
        const credential = { ID: vault.ID, UserId: this.user.id, Credentials: vaultCredentials.credentials };
        await this.checkVaultInCluster(vault, credential);
    }

    private async checkVaultInCluster(vault, credential) {
        this.waitingForResultTest = true;
        const vaultInCluster = await this.store.dispatch({
            type: agentActions.CHECK_VAULT_IN_CLUSTER, payload: { vault }
        });
        if (vaultInCluster) {
            await this.showClusterDialog(vault, credential);
        } else {
            await this.showAdditionalOptionDialog(vault, credential);
        }
    }

    private async showClusterDialog(vault, credential) {
        const onConfirm = async (data) => {
            this.clusterId = data.selected.ID;
            await this.showAdditionalOptionDialog(vault, credential);
        };
        const dialogData = {
            clusters: this.clusterList,
            title: 'Select Cluster',
            fieldName: 'Cluster'
        };
        await this.dialogManagerService.showDialog(dialogData, onConfirm, ClusterDialogComponent, 'cluster-dialog');
    }

    private async showAdditionalOptionDialog(vault, credential) {
        const htmlConnTemplate = await this.getHtmlTemplate(vault);
        const testDataObject = {
            clusterId: -1,
            configuration: vault,
            credentials: credential,
            connection: { VaultId: vault.ID, Connection: {} }
        };

        await this.dialogManagerService.showVaultDialog(
            htmlConnTemplate,
            {
                title: 'Vault Details',
                buttons: [
                    {
                        text: 'Test Connection', onClick: (instance, onClose) => {
                            onClose(instance.data);
                        }
                    },
                    {
                        text: 'Cancel', onClick: (_, onClose) => {
                            onClose();
                        }
                    }
                ],
                setData: (instance) => {
                    instance.data = {
                        credentials: { },
                        connection: { }
                    };
                }
            },
            async (data) => {
                testDataObject.connection.Connection = !this.isConnection ? null : data.connection;
                testDataObject.clusterId = this.clusterId;
                await this.store.dispatch({ type: vaultActions.TEST_VAULT_CONNECTION,
                    payload: { testData: testDataObject }
                });
                this.waitingForResultTest = false;
            }
        );
    }

    private async getHtmlTemplate(vault): Promise<string> {
        return new Promise(async (resolve) => {
            const connectionTemplate = await this.store.dispatch({
                type: vaultActions.POST_VAULT_CONNECTION, payload: { vault }
            });
            this.isConnection = true;
            resolve(connectionTemplate);
        });
    }

    private getVaultById(id) {
        const vaultsState = this.store.getState().vaults;
        if (vaultsState.vaults && vaultsState.vaults.length > 0) {
            return vaultsState.vaults.find((vault: any) => vault.ID === id);
        }
        return undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/user/user.component.ts